export function computeRamCapacity(capacity, slots, quantity = 1) {
    let capacityText = "";

    if (capacity) {
        capacity = capacity.replace(" ", "");
        const totalSlots = Math.abs(slots) * Number(quantity);
        const suffix = capacity.match(/([^\d]+)/)[0].trim();
        const realSize = Number.parseInt(capacity) * totalSlots;

        capacityText = `${realSize}${suffix} <small>(${totalSlots}X${capacity})</small>`;
    }

    return capacityText;
}

export function getRamSlotsFromText(capacityText, quantity = 1) {
    if (capacityText) {
        const slotsCapacity = capacityText.split(/ ?x ?/i);

        return computeRamCapacity(slotsCapacity[1], slotsCapacity[0], quantity);
    }

    return "";
}

export function getStep3RamText(ramText) {
    if (!ramText) {
        return "";
    }

    // First position is omitted on purpose since it is not used.
    const [, name, speed, totalCapacity, slotsCapacity] = ramText.match(/(.*?)(\d+mhz|)\s(\d+GB)\s(\([^)]+\))/i);
    const speedText = `${speed} <small>(max speed)</small>`;
    // Remember the space at the end of the first line.
    const parsedText = `${name.trim()} ${speedText} ` +
        `${totalCapacity} <small>${slotsCapacity.replace(/ ?x ?/i, "X")}</small>`;

    return parsedText;
}
